import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Viewerlayer } from "../../model/viewerlayer";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { IProjectAOI } from "../../interfaces/i-project-aoi";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-layer-item",
  templateUrl: "./layer-item.component.html",
  styleUrls: ["./layer-item.component.scss"],
  standalone: false,
})
export class LayerItemComponent implements OnInit {
  _layer: Viewerlayer;

  _parent: Viewerlayer;

  _selectedAOIS: IProjectAOI[] = [];

  @Input() set layer(layer: Viewerlayer) {
    this._layer = layer;
  }

  @Input() set parent(parent: Viewerlayer) {
    this._parent = parent;
  }

  @Input() childs = true;

  @Input() ordering: string;

  get layer(): Viewerlayer {
    return this._layer;
  }

  @Input() zoomLevel: number;

  @Input() debug: boolean;

  @Input() mode3D: boolean;

  @Output() changeVisibilityEvent = new EventEmitter<{
    layer: Viewerlayer;
    value: boolean;
  }>();

  @Output() updateCollectionOrderEvent = new EventEmitter<Viewerlayer>();

  @Output() toggleContrastEvent = new EventEmitter<Viewerlayer>();

  @Output() fitBBoxEvent = new EventEmitter<string>();

  @Output() showInfoEvent = new EventEmitter<Viewerlayer>();

  someChecked: boolean = false;

  showColorEnhancement = false;

  has3D = false;

  has2D = false;

  hasChilds = false;

  hasEnabledChilds = false;

  enabledChilds: Viewerlayer[];

  @Output() extentParentEvent = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.showColorEnhancement = this.enabledColorEnhancement();
    this.has3D = this.show3DTag();
    this.has2D = this.show2DTag();

    this.hasChilds = this.showChilds();
    this.enabledChilds = this.layer.aois?.filter((aoi) => aoi.enabled);
    this.hasEnabledChilds = !!this.enabledChilds?.length;
  }

  changeVisibility(event: any): void {
    this.changeVisibilityEvent.emit({
      layer: this.layer,
      value: event.checked,
    });
  }

  changeChildOrder(event: CdkDragDrop<string[]>): void {
    if (this.layer.aois?.length) {
      moveItemInArray(this.layer.aois, event.previousIndex, event.currentIndex);
      this.updateCollectionOrderEvent.emit(this.layer);
    }
    if (this.layer.childs?.length) {
      moveItemInArray(this.layer.childs, event.previousIndex, event.currentIndex);
      this.updateCollectionOrderEvent.emit(this.layer);
    }
  }

  enabledColorEnhancement(): boolean {
    // only show enhancement color on childs
    if (this.zoomLevel < ViewerConstants.COLLECTION_TIMELINE_ZOOM_LEVEL) {
      return this.layer.childs?.some((child) => {
        return child.config?.enhancements?.includes(ViewerConstants.LAYER_ENHANCEMENTS.COLOR_STRETCH) || false;
      });
    }
    if (!this.layer.childs?.length && !this.layer.aois?.length) {
      return this.layer.config?.enhancements?.includes(ViewerConstants.LAYER_ENHANCEMENTS.COLOR_STRETCH) || false;
    }

    return false;
  }

  showChilds(): boolean {
    return !!this.layer.aois?.length;
  }

  fitToBbox(coverage: string) {
    this.fitBBoxEvent.emit(coverage);
  }

  toggleLayerContrast(layer: Viewerlayer) {
    this.toggleContrastEvent.emit(layer);
  }

  showLayerInfo(layer: Viewerlayer) {
    this.showInfoEvent.emit(layer);
  }

  show3DTag(): boolean {
    return (
      !this.layer.aoi &&
      this.layer.enabled &&
      this.layer.enableOblique &&
      this.layer.projects?.some((project) =>
        project.orientations.some((o) => ViewerConstants.OBLIQUE_ORIENTATIONS.includes(o)),
      )
    );
  }

  show2DTag(): boolean {
    return !this.layer.aoi && this.layer.enabled;
  }

  extentParent(extentParent: boolean) {
    this.layer.cardExpansed = extentParent;
    this.extentParentEvent.emit(true);
  }
}
